import React, { useState } from "react";

// import { AlertStatus } from "../../lib/enums";

const AlertContext = React.createContext(null);
AlertContext.displayName = "AlertContext";

const AlertProvider = ({ children }) => {
  const [alert, setAlert] = useState("");
  const [alertText, setAlertText] = useState(null);

  return (
    <AlertContext.Provider
      value={{
        alert: alert,
        alertText: alertText,
        success: (text, timeout = 5) => {
          setAlertText(text);
          setAlert("Success");
          // Only stay persistent if explicitly set to 0
          if (timeout !== 0) {
            setTimeout(() => {
              setAlert("");
              setAlertText("");
            }, timeout * 1000);
          }
        },
        error: (text, timeout = 5) => {
          setAlertText(text);
          setAlert("Error");
          // Only stay persistent if explicitly set to 0
          if (timeout !== 0) {
            setTimeout(() => {
              setAlert("");
              setAlertText("");
            }, timeout * 1000);
          }
        },
        clear: () => {
          setAlert("");
          setAlertText("");
        },
      }}
    >
      {children}
    </AlertContext.Provider>
  );
};

export { AlertProvider };
export default AlertContext;
